import { createReducer } from '@reduxjs/toolkit'

import { TResourceStatusItem } from 'redux/api/ResourceStatuses'
import * as authenticationActions from '../../actions/Authentication/actions'
import * as actions from '../../actions/ResourceStatuses/actions'
import * as dashboardActions from '../../actions/Dashboards/actions'
import * as reportActions from '../../actions/Reports/actions'

export interface ResourceStatusesReducerType {
  byId: Record<string, TResourceStatusItem>
}

const INITIAL_STATE: ResourceStatusesReducerType = {
  byId: {}
}

function buildById(
  items: TResourceStatusItem[]
): Record<string, TResourceStatusItem> {
  const byId: Record<string, TResourceStatusItem> = {}

  items.forEach((item) => {
    byId[item.resource_id] = item
  })

  return byId
}

const resourceStatusesReducer = createReducer(INITIAL_STATE, (builder) => {
  builder
    .addCase(actions.getResourceStatusesSuccess, (state, action) => {
      state.byId = buildById(action.payload)
    })
    .addCase(actions.putResourceStatusSuccess, (state, action) => {
      state.byId = buildById(action.payload)
    })
    .addCase(dashboardActions.getOneSuccess, (state, action) => {
      const id = action.payload.dashboard_group_id
      const now = new Date().toISOString()

      state.byId[id] = {
        ...state.byId[id],
        resource_id: id,
        latest_visit: now,
        favorite: state.byId[id]?.favorite ?? false
      }
    })
    .addCase(reportActions.visitReportSuccess, (state, action) => {
      const id = action.payload
      const now = new Date().toISOString()

      state.byId[id] = {
        ...state.byId[id],
        resource_id: id,
        latest_visit: now,
        favorite: state.byId[id]?.favorite ?? false
      }
    })
    .addCase(authenticationActions.signOut, () => INITIAL_STATE)
    .addDefaultCase((state) => state)
})

export default resourceStatusesReducer
